var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-card",
    { attrs: { flat: "" } },
    [
      _c("v-card-title", [_vm._v(" Events summary ")]),
      _c("v-data-table", {
        staticClass: "elevation-1",
        attrs: {
          headers: [
            { text: "Date", value: "date" },
            { text: "Freq Recovery Rate", value: "freqRecoveryRate" },
            { text: "Nadir", value: "nadir" },
            { text: "Freq Settling", value: "freqSettling" },
            { text: "ROCOF", value: "rocof" },
            { text: "Final Offset", value: "steadyStateOffset" },
            { text: "Time To Nadir", value: "timeToNadir" },
          ],
          items: _vm.outputs,
          dense: "",
          "disable-pagination": "",
          "hide-default-footer": "",
        },
        scopedSlots: _vm._u([
          {
            key: "item.date",
            fn: function (ref) {
              var item = ref.item
              return [
                item.date
                  ? _c("span", [
                      _c("span", { staticClass: "text-caption grey--text" }, [
                        _vm._v(" " + _vm._s(_vm.formatDate(item.date)) + " "),
                      ]),
                      _vm._v(" " + _vm._s(_vm.formatTime(item.date)) + " "),
                    ])
                  : _c("span", [_vm._v("-")]),
              ]
            },
          },
          {
            key: "item.freqRecoveryRate",
            fn: function (ref) {
              var item = ref.item
              return [
                item.freqRecoveryRate !== undefined
                  ? _c("span", [
                      _vm._v(
                        " " +
                          _vm._s(item.freqRecoveryRate.toFixed(2)) +
                          " Hz/s "
                      ),
                    ])
                  : _c("span", [_vm._v("-")]),
                item.freqRecoveryRate === undefined ||
                item.freqRecoveryRate < 0.01
                  ? _c(
                      "v-icon",
                      {
                        staticClass: "ml-1",
                        attrs: {
                          color: "warning",
                          small: "",
                          title:
                            "Warning: Frequency recovery rate is zero or missing",
                        },
                      },
                      [_vm._v(" mdi-alert ")]
                    )
                  : _vm._e(),
              ]
            },
          },
          {
            key: "item.freqSettling",
            fn: function (ref) {
              var item = ref.item
              return [
                item.freqSettling != null
                  ? _c("span", [
                      _vm._v(
                        " " + _vm._s(item.freqSettling.toFixed(2)) + " Hz "
                      ),
                      item.freqSettlingStd !== undefined
                        ? _c(
                            "span",
                            { staticClass: "text-caption grey--text" },
                            [
                              _vm._v(
                                " ±" +
                                  _vm._s(item.freqSettlingStd.toFixed(2)) +
                                  " "
                              ),
                            ]
                          )
                        : _vm._e(),
                    ])
                  : _c("span", { staticClass: "text-caption grey--text" }, [
                      _vm._v(" did not settle "),
                    ]),
              ]
            },
          },
          {
            key: "item.nadir",
            fn: function (ref) {
              var item = ref.item
              return [
                item.nadir !== undefined
                  ? _c("span", [
                      _vm._v(" " + _vm._s(item.nadir.toFixed(2)) + " Hz "),
                    ])
                  : _c("span", [_vm._v("-")]),
              ]
            },
          },
          {
            key: "item.rocof",
            fn: function (ref) {
              var item = ref.item
              return [
                item.rocof !== undefined
                  ? _c("span", [
                      _vm._v(" " + _vm._s(item.rocof.toFixed(2)) + " Hz/s "),
                    ])
                  : _c("span", [_vm._v("-")]),
              ]
            },
          },
          {
            key: "item.steadyStateOffset",
            fn: function (ref) {
              var item = ref.item
              return [
                item.steadyStateOffset !== undefined
                  ? _c("span", [
                      _vm._v(
                        " " +
                          _vm._s(item.steadyStateOffset.toFixed(2)) +
                          " mHz "
                      ),
                    ])
                  : _c("span", [_vm._v("-")]),
              ]
            },
          },
          {
            key: "item.timeToNadir",
            fn: function (ref) {
              var item = ref.item
              return [
                _vm._v(
                  " " +
                    _vm._s(
                      item.timeToNadir !== undefined
                        ? item.timeToNadir.toFixed(2)
                        : "-"
                    ) +
                    " s "
                ),
                item.timeSimulated !== undefined
                  ? _c("span", { staticClass: "text-caption grey--text" }, [
                      _vm._v(
                        " out of " + _vm._s(item.timeSimulated.toFixed(2)) + " "
                      ),
                    ])
                  : _vm._e(),
              ]
            },
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }